(function ($, Cart, document, window, MarketPlace, Handlebars, Scrollbar) {
    'use strict';

    Cart.setup('#cart-preview, #mobile-cart-preview');

    var $document = $(document);

    function enableButtons() {
        $('.qty-button', '#order-cart-summary').not('.disabled-pernament').removeClass('disabled');
        $('.cart-order-product').removeClass('disabled');
    }

    $document.ready(function () {
        Cart.setLoaded(MarketPlace.config.cartLoaded);

        if (!MarketPlace.config.cartLoaded && !$('body').hasClass('page-error')) {
            Cart.runCommand(MarketPlace.config.cartPreview);
        }

        enableButtons();
    });

    $document.on('click', '.cart-order-product', function (e) {
        var
            $this = $(this),
            redirectToCart = $this.hasClass('product-order-now'),
            url = $this.attr('href');

        if (redirectToCart) {
            $document.trigger('loader.continue');
        }

        Cart.runCommand(url).then(function () {
            if (redirectToCart) {
                window.location.href = Cart.getCartUrl();
            }
        });

        e.preventDefault();
    });

    $document.on('click', '.qty-button', function (e) {
        var
            $this = $(this),
            url = $this.attr('href');

        if ($this.hasClass('disabled')) {
            return false;
        }

        e.preventDefault();
        e.stopPropagation();
        
        if($this.data('bundle'))
        {
            $('#remove-bundle-product').modal();
            $("#remove-bundle-product .remove-bundle").click(function(){
        var $qtyButtons = $('.qty-button', '#order-cart-summary').addClass('disabled');

        Cart.runCommand(url).then(function () {
            $qtyButtons.not('.disabled-pernament').removeClass('disabled');
                    
                    $('#remove-bundle-product').modal("hide");
                });
        });

            return;
        }
        
        var $qtyButtons = $('.qty-button', '#order-cart-summary').addClass('disabled');
        
        Cart.runCommand(url).then(function () {
            $qtyButtons.not('.disabled-pernament').removeClass('disabled');
        });
    });

    $document.on('click', '.promo-code-action', function (e) {
        var
            $form = $(this).closest('form'),
            url = $form.attr('action'),
            params = {
                promocode: $('#promocode-input-field').val()
            };

        $('#promocode-tooltip').addClass('hidden');

        Cart.runCommand(url, params).then(function (response) {
            if (!response.status) {
                var $promoCodeTooltip = $('#promocode-tooltip');

                $promoCodeTooltip.removeClass('hidden').text(response.message);

                setTimeout(function () {
                    $promoCodeTooltip.addClass('hidden');
                }, 5000);
            }
        });

        e.preventDefault();
    });

    $document.on('keypress', '#promocode-input-field', function(e) {
        if (e.which === 13) {
            $document.find('.promo-code-action').trigger('click');
            return false;
        }
    });

    $document.click(function (e) {
        if (!$(e.target).closest('#promocode-tooltip').length) {
            $('#promocode-tooltip').addClass('hidden');
        }
    });

    $document.on('click', '.cart-next-step', function (e) {
        var location = $('#cart-next-step').attr('href');

        if(location)
        {
            window.location = location;
        }

        e.preventDefault();
    });

    var
        $body = $('body'),
        $productOverviewPlaceholder = $('#product-overview-placeholder'),
        $cartStepOnePageContentBody = $('#cart-step-1-page-content').find('.content-body');

    enquire.register("screen and (min-width: 1200px)", {
        match: function () {
            $document.on('click', '.show-product-modal', function (e) {
                e.preventDefault();

                $.getJSON(this.href).success(function (response) {
                    $productOverviewPlaceholder.html(response.html).addClass('overview-show');
                    $body.addClass('product-info-expanded');
                    $cartStepOnePageContentBody.css('min-height', ($productOverviewPlaceholder.height() + 100));

                    $('#overview-container').modal('show');
                    $('#product-gallery').lightGallery({
                        thumbContHeight: 177,
                        thumbWidth: 125,
                        thumbMargin: 16
                    });

                        $('.list-collapse .active .item-body').css('display','block');
                    });
                });
                $productOverviewPlaceholder.on('shown.bs.tab', function () {
                    var $this = $(this);

                $cartStepOnePageContentBody
                    .css('min-height', 0)
                    .css('min-height', ($this.height() + 100));
            });

            $document.on('click', '#product-overview-placeholder .list-collapse li a', function () {
                var
                    $this = $(this),
                    $listCollapse = $productOverviewPlaceholder.find('.list-collapse'),
                    countItems = $listCollapse.find('> li').length,
                    newActiveEl = $this.siblings('.item-body').height(),
                    addHeight = 417,
                    setHeight = addHeight + (countItems * 45) + newActiveEl;

                $cartStepOnePageContentBody.css('min-height', setHeight + 500);

                    setTimeout(function () {
                        $cartStepOnePageContentBody.css('min-height', setHeight);
                    },250);
                });
            },
            unmatch: function () {
                $document.on('click', '.show-product-modal', function (e) {
                    e.preventDefault();

                $.getJSON(this.href).success(function (response) {
                    $productOverviewPlaceholder.html(response.html).show();
                    $body.addClass('no-scroll product-info-expanded');

                    $('#product-gallery').lightGallery({
                        thumbContHeight: 177,
                        thumbWidth: 125,
                        thumbMargin: 16
                    });

                    $('.list-collapse .active .item-body').css('display', 'block');
                });
            });
        }
    });

    $(window).on('resize', function () {
        enquire.register("screen and (min-width: 1200px)", {
            match: function () {
                if ($('.product-overview').hasClass('overview-show') && $body.hasClass('product-info-expanded')) {
                    $body.removeClass('no-scroll');
                }

            },
            unmatch: function () {
                if ($('.product-overview').hasClass('overview-show')) {
                    $body.addClass('no-scroll');
                }
            }
        });
    });

    enquire.register("screen and (min-width: 1200px)", {
        match: function () {
            $document.on('click', '.close-product-overview', function () {
                $productOverviewPlaceholder.empty().removeClass('overview-show');
                $('#overview-container').modal('hide');
                $cartStepOnePageContentBody.css('min-height', 0);
            });
        },
        unmatch: function () {
            $document.on('click', '.close-product-overview', function () {
                $productOverviewPlaceholder.empty().hide();
                $body.removeClass('no-scroll product-info-expanded');
                $('#overview-container').modal('hide');
            });
        }
    });

    $(document).on('click', '.open-cart-product-licenses', function (e) {
        e.preventDefault();

        $.get(this.href).done(function (response) {
            $('body').find('.modal').remove();
            sliderLicences = null;

            $('body').append(response);

            var $modal = $('.modal');
            $modal.addClass('modal-licenses');
            $modal.find('.modal-dialog').wrapAll('<div class="modal-scroll-container"></div>');

            requestAnimationFrame(function() {
                handleLicenseSlider();
                $modal.modal('show');
            });
        });
    });

    var sliderLicences = null;

    function handleLicenseSlider() {
        var $modalBody = $('.modal-licenses .modal-body.two-sections');

        if (!$modalBody.length) return;

        if ($(window).width() < 768) {
            if (!sliderLicences) {
                $modalBody.each(function () {
                    var $sections = $(this).find('.modal-section');

                    var maxHeight = 0;
                    var $tallest = null;
                    $sections.each(function () {
                        var h = $(this).outerHeight();
                        if (h > maxHeight) {
                            maxHeight = h;
                            $tallest = $(this);
                        }
                    });
                    if ($tallest) {
                        $tallest.css('position', 'relative');
                    }

                    if (!$sections.parent().hasClass('modal-slider-container')) {
                        $sections.wrapAll('<div class="modal-slider-container"></div>');
                    }
                });

                sliderLicences = $modalBody.find('.modal-slider-container').lightSlider({
                    item: 2,
                    slideMargin: 0,
                    controls: true,
                    pager: true,
                    enableDrag: true,
                    adaptiveHeight: true,
                    responsive: [
                        { breakpoint: 768, settings: { item: 2 } },
                        { breakpoint: 580, settings: { item: 1 } },
                    ],
                    onSliderLoad: function() {
                        var $pagerContainer = $('.modal-licenses').find('ul.lSPager');
                        $pagerContainer.wrap('<div class="modal-licenses-actions"></div>');

                        $('.modal-licenses .modal-licenses-actions').prepend(
                            '<a class="custom-arrow custom-arrow-prev disabled">' +
                                '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '<path d="M9.98293 2L7.99253 3.67067L4.01172 7.01202L8.01172 10.3373L10.0117 12" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
                                '</svg>' +
                            '</a>'
                        );

                        $('.modal-licenses .modal-licenses-actions').append(
                            '<a class="custom-arrow custom-arrow-next">' +
                                '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '<path d="M4.02879 2L6.01919 3.67067L10 7.01202L6 10.3373L4 12" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
                                '</svg>' +
                            '</a>'
                        );

                        var greenIndex = $('.modal-slider-container .modal-section').index($('.modal-section.section-green'));
                        if (greenIndex > -1) {
                            sliderLicences.goToSlide(greenIndex);
                        }

                        updateArrowsDisabled();
                    },
                    onBeforeSlide: updateArrowsDisabled,
                    onAfterSlide: updateArrowsDisabled
                });
                $(document).off('click.customArrows').on('click.customArrows', '.custom-arrow-prev, .custom-arrow-next', function () {
                    var slides = $('.modal-section').not('.clone');
                    var total = slides.length;
                    var currentIndex = slides.index($('.modal-section.slide-active').not('.clone'));
                    if (currentIndex === -1) currentIndex = 0;

                    if ($(this).hasClass('custom-arrow-prev') && currentIndex > 0) sliderLicences.goToPrevSlide();
                    if ($(this).hasClass('custom-arrow-next') && currentIndex < total - 1) sliderLicences.goToNextSlide();
                });
            }
        } else {
            if (sliderLicences && typeof sliderLicences.destroy === "function") {
                sliderLicences.destroy();
                sliderLicences = null;
                $modalBody.each(function () {
                    var $container = $(this).find('.modal-slider-container');
                    if ($container.length) {
                        $container.children().unwrap();
                    }
                });
                $('.modal-licenses-actions').remove();
                $modalBody.find('.modal-section').css('position', '');
            }
        }
    }

    function updateArrowsDisabled() {
        var slides = $('.modal-section').not('.clone');
        var total = slides.length;
        var currentIndex = slides.index($('.modal-section.slide-active').not('.clone'));
        if (currentIndex === -1) currentIndex = 0;

        var $prevArrow = $('.custom-arrow-prev');
        var $nextArrow = $('.custom-arrow-next');

        $prevArrow.removeClass('disabled');
        $nextArrow.removeClass('disabled');

        if (currentIndex === 0) $prevArrow.addClass('disabled');
        if (currentIndex === total - 1) $nextArrow.addClass('disabled');

        var $actions = $('.modal-licenses-actions');
        if (total < 3) {
            $actions.addClass('hidden-actions');
        } else {
            $actions.removeClass('hidden-actions');
        }
    }

    $(window).on('resize', handleLicenseSlider);
        $(document).on('shown.bs.modal', '.modal-licenses', handleLicenseSlider);
        $(document).on('hidden.bs.modal', '.modal-licenses', function () {
        if (sliderLicences) {
            sliderLicences.destroy();
            sliderLicences = null;
            $(this).find('.modal-slider-container').children().unwrap();
            $(this).find('.modal-licenses-actions').remove();
            $(this).find('.modal-section').css('position', '');
        }
    });
    
    $(document).on('click', '.modal-licenses .tabs .nav li', function (e) {
        var $el = $(this);
        var $parent = $el.parent();

        $parent.stop().animate({
            scrollLeft: $parent.scrollLeft() + $el.position().left - ($parent.width()/2) + ($el.outerWidth(true)/2)
        }, 300);
    });

    $document.on('click', '.change-product-license', function (e) {
        Cart.runCommand(this.href).then(function () {
            $('.modal').modal('hide');
        });

        e.preventDefault();
    });

    $document.on('change, ifChanged', '.cart-addon-switcher', function () {
        var
            $this = $(this),
            url = $this.is(':checked') ? $this.data('url-add') : $this.data('url-remove');

        Cart.runCommand(url);
    });

    $document.on('click', '.add-addon-to-cart-on-product-page', function (e) {
        var
            $this = $(this),
            url = $this.attr('href');

        Cart.runCommand(url);

        $this.prop('disabled', true).attr('disabled', 'disabled');

        e.preventDefault();
    });

    $document.on('click', '.select-all-addons-in-group', function (e) {
        var
            $this = $(this),
            url = $this.data('url'),
            cartItems = {},
            $inputs = $this.closest('.addon-group').find('input[type="checkbox"]:not([disabled])');

        $inputs.parent().addClass('checked');
        $this.prop('disabled', true).attr('disabled', 'disabled');

        $inputs.each(function () {
            var
                $this = $(this),
                cartItemId = $this.data('cart-item-id'),
                addonId = $this.val();

            if (!cartItems.hasOwnProperty(cartItemId)) {
                cartItems[cartItemId] = [];
            }

            cartItems[cartItemId].push(addonId);
        });

        Cart.runCommand(url, {
            cartItems: cartItems
        });

        e.preventDefault();
    });

    $document.on('click', '.unselect-all-addons-in-group', function (e) {
        var
            $this = $(this),
            url = $this.data('url'),
            cartItems = {},
            $inputs = $this.closest('.addon-group').find('input[type="checkbox"]:not([disabled])');

        $inputs.parent().removeClass('checked');
        $this.prop('disabled', true).attr('disabled', 'disabled');

        $inputs.each(function () {
            var
                $this = $(this),
                cartItemId = $this.data('cart-item-id'),
                addonId = $this.val();

            if (!cartItems.hasOwnProperty(cartItemId)) {
                cartItems[cartItemId] = [];
            }

            cartItems[cartItemId].push(addonId);
        });

        Cart.runCommand(url, {
            cartItems: cartItems
        });

        e.preventDefault();
    });

    $document.on('ifUnchecked', '.addon-group input[type="checkbox"]', function () {
        $(this).closest('.addon-group').find('.select-all-addons-in-group, .unselect-all-addons-in-group').prop('disabled', false);
    });

    $document.on('click', '.show-addon-info', function (e) {
        $(this).closest('.addon-group').addClass('w-info-expanded');

        e.preventDefault();
    });

    $document.on('click', '.open-product-addon-info', function (e) {
        var $this = $(this);

        $this.closest('.addon-group').addClass('w-included-expanded').find('.included.addon-info').hide();

        $($this.data('target')).show();

        e.preventDefault();
    });

    $document.on('click', '.close-addon-info', function (e) {
        $(this).closest('.addon-group').removeClass('w-info-expanded');

        e.preventDefault();
    });

    $document.on('click', '.close-product-addon-info', function (e) {
        $(this).closest('.addon-group').removeClass('w-included-expanded').find('.included.addon-info').hide();

        e.preventDefault();
    });

    $document.on('click', '.add-to-cart-addon-by-checkbox', function (e) {
        var $this = $(this).prop('disabled', true);

        $($this.data('target')).iCheck('check');

        e.preventDefault();
    });

    $document.on('click', '.remove-from-cart-addon-by-checkbox', function (e) {
        var $this = $(this).prop('disabled', false);

        $($this.data('target')).iCheck('uncheck');

        e.preventDefault();
    });

    $document.on('mouseenter', '.product-widget-tile', function () {
        $(this).closest('.product-widget-tile').addClass('w-info-expanded');
    });

    $document.on('mouseleave', '.product-widget-tile', function () {
        $(this).closest('.product-widget-tile').removeClass('w-info-expanded w-review-expanded');
    });

    $document.on('click', '.show-product-tile-reviews', function (e) {
        $(this).closest('.widget').addClass('w-review-expanded');

        e.preventDefault();
    });

    $document.on('click', '.close-product-tile-reviews', function (e) {
        $(this).closest('.widget').removeClass('w-review-expanded');

        e.preventDefault();
    });

    $document.on('cart/runCommand/before', function () {
        $('#order-cart-summary-loader').removeClass('hidden');
    });

    $document.on('cart/runCommand/success', function (e, url, response) {
        Scrollbar.update();
        $('#cart-next-step').toggleClass('disabled-event', !response.cart.qty);
        $('#order-cart-summary-loader').addClass('hidden');

        enableButtons();
    });

    function initWidgetSlider() {
        $('.widget-slider').lightSlider({
            slideMargin: 16,
            autoWidth: true,
            pager: false,
            prevHtml: '<i class="zmdi zmdi-arrow-left"></i>',
            nextHtml: '<i class="zmdi zmdi-arrow-right"></i>',
            responsive: [{
                breakpoint: 1186,
                settings: {
                    item: 2,
                    autoWidth: false
                }
            }, {
                breakpoint: 579,
                settings: {
                    item: 1,
                    autoWidth: true,
                    slideMargin: 8
                }
            }],
            onSliderLoad: function () {
                $('.widget-slider').removeClass('cS-hidden');
                $('.widget-slider-loader').addClass('hidden');
                $('.widget-slider-container').removeClass('loading load');
            }
        });
    }

    (function () {
        var
            $recommendedContent = $('#cart-first-step-content'),
            $loadMoreAdditionalProducts = $('#load-more-additional-products'),
            hasPagination = $recommendedContent.data('type') === '_list',
            productsPerPage = 3,
            showProductsCount = productsPerPage + 3;

        $document.on('cart/additional_products/updated', function () {
            if (hasPagination) {
                var $products = $recommendedContent.find('.additional-product-widget');

                $products.addClass('hidden').slice(0, showProductsCount).removeClass('hidden');
                showProductsCount = $products.filter(':not(.hidden)').length;

                if (showProductsCount < productsPerPage) {
                    showProductsCount = productsPerPage;
                }

                if (showProductsCount >= $products.length) {
                    $loadMoreAdditionalProducts.fadeOut();
                } else {
                    $loadMoreAdditionalProducts.removeClass('hidden').fadeIn();
                }
            } else {
                initWidgetSlider();
            }
        });

        $document.trigger('cart/additional_products/updated');

        $loadMoreAdditionalProducts.click(function (e) {
            var $products = $recommendedContent.find('.additional-product-widget');

            $products.slice(showProductsCount, showProductsCount += productsPerPage).removeClass('hidden');

            if (showProductsCount >= $products.length) {
                $loadMoreAdditionalProducts.fadeOut();
            }

            e.preventDefault();
        });
    })();

    /**
     * Section for 2 cart step
     */
    (function () {

        $document.on('mouseenter', '.w-addon .widget-header, .w-addon .short-desc, .w-addon .long-desc', function () {
            $(this).closest('.w-addon').addClass('w-desc-expanded');
        });

        $document.on('mouseleave', '.w-addon .widget-header, .w-addon .short-desc, .w-addon .long-desc', function () {
            var $addon = $(this).closest('.w-addon');
            if (!$addon.hasClass('w-desc-pinned')) {
                $addon.removeClass('w-desc-expanded');
            }
        });

        $document.on('mouseenter', '.w-addon .widget-header', function () {
            $(this).closest('.w-addon').addClass('w-head-hover');
        });
        $document.on('mouseleave', '.w-addon .widget-header', function () {
            $(this).closest('.w-addon').removeClass('w-head-hover');
        });

        $document.on('click', function (e) {
            var $trigger = $(e.target).closest('.w-addon .widget-header, .w-addon .short-desc');
            if ($trigger.length) {
                var $addon = $trigger.closest('.w-addon');
                var isOpen = $addon.hasClass('w-desc-pinned');
                $('.w-addon').removeClass('w-desc-pinned w-desc-expanded');
                if (!isOpen) {
                    $addon.addClass('w-desc-pinned w-desc-expanded');
                    if ($(e.target).closest('.widget-header').length) {
                        $addon.addClass('w-head-hover');
                    }
                } else {
                    $addon.removeClass('w-head-hover');
                }
                return;
            }
            $('.w-addon').removeClass('w-desc-pinned w-desc-expanded w-head-hover');
        });

        var $addons = $('#cart-addons-container');

        if ($addons.length) {
            var url = $addons.data('url');

            $document.on('cart/runCommand/success', function () {
                $.get(url).success(function (response) {
                    $addons.html(response);

                    $('body').find('input:not(.icheck-input)').iCheck({
                        checkboxClass: 'checkbox-styled',
                        radioClass: 'radio-styled',
                        increaseArea: '40%'
                    });

                    Scrollbar.update();
                });
            });
        }
    })();

    /**
     * Section for 1 cart step
     */

    (function () {
        var
            lastDiscount = 0,
            $tierPricesStats = $('#tier-prices-stats'),
            $tierPricesProgress = $('#tier-prices-stats-progress');

        function promoSlider() {
            var discountValue = parseInt($('#tier-prices-stats-achieved-discount').text());

            if (isNaN(discountValue) === true) {
                discountValue = 0;
            }

            var transformValue = -discountValue * 7;

            if (transformValue < -105) {
                $tierPricesProgress.find('.values-container').css('transform', 'translateX(-105%)');
            } else {
                $tierPricesProgress.find('.values-container').css('transform', 'translateX(' + transformValue + '%)');
            }

            if (lastDiscount !== discountValue) {
                $tierPricesProgress.find('.circle.active').last().addClass('circle-animated');
            }

            lastDiscount = discountValue;
        }

        if ($tierPricesStats.length) {
            var
                url = $tierPricesStats.data('url'),
                $recommendedContent = $('#cart-first-step-content');

            $document.on('cart/runCommand/success', function (e, cartUrl, response) {
                var qty = response.cart.qty;

                $recommendedContent.find('.widget-slider-loader').removeClass('hidden');
                $recommendedContent.find('.widget-slider-container').addClass('load');

                $.get(url).success(function (response) {
                    if (qty) {
                        $recommendedContent.find('.widget-slider-container').addClass('load');
                        $tierPricesStats.html(response.stats_view).parent().removeClass('hidden');
                        $tierPricesProgress.html(response.progress_view);
                    } else {
                        $tierPricesStats.parent().addClass('hidden');
                    }

                    $recommendedContent.html(response.recommended_view);
                    $recommendedContent.find('.widget-slider-container').addClass('load');
                    $recommendedContent.find('.widget-slider-loader').removeClass('hidden');
                    $document.trigger('cart/additional_products/updated');
                    promoSlider();
                });
            });
        }
    })();

})(jQuery, Cart, document, window, MarketPlace, Handlebars, Scrollbar);
